import { mapGetters } from 'vuex';
import _ from 'lodash';
import { planTypes } from '@/common/constants';
import { softBundle4Pbx } from '@/plans/ZOOM_PHONE/mixin/soft-bundle-pbx';

export default {
  computed: {
    ...mapGetters(['softBundleConfiguration']),
    /**
     * @description get zoom meeting soft bundle configuration
     * @returns {SoftBundlePlanConfigBean}
     */
    softBundleMeetingConfig() {
      return _.get(this.softBundleConfiguration, [planTypes.ZOOM_MEETING]);
    },
    billingCycleSwitchDepPlanTypeList() {
      return this.softBundleMeetingConfig?.billingCycleSwitch?.switchPlanTypeList ?? [];
    },
    soft_bundle_hiddenPlanCardRemove() {
      return this.softBundleMeetingConfig?.hiddenRemove;
    },
    soft_bundle_hiddenSwitchCategoryEntry() {
      return this.softBundleMeetingConfig?.hiddenSwitchCategoryEntry;
    }
  },
  methods: {
    switchOtherPlanCycle4SoftBundle(newCycle) {
      const planTypeList = this.billingCycleSwitchDepPlanTypeList;

      if (_.includes(planTypeList, planTypes.ZOOM_PHONE)) {
        softBundle4Pbx?.cycleInstance?.handleGroup0Change(newCycle);
      }
    },
  },
};
